import * as _ from 'lodash';

//  Note that we are intentionally using this Project type (and not the model-typings one), since it includes the associations that we need.
import type { Project } from '../../../../types';

const projectUpdateHooksSettingsFields = [
  'active',
  'type',
  'secret_key',
  'scheduled_interval',
  'scheduled_interval_length',
  'scheduled_interval_time',
] as const;
type ProjectUpdateHooksSettingsFields = typeof projectUpdateHooksSettingsFields[number];

export type ProjectUpdateHook = Pick<Required<Project>['updateHook'], ProjectUpdateHooksSettingsFields>;

export type ProjectUpdateHooksSettings = {
  isProvidedProject: boolean;
  updateHook: ProjectUpdateHook | null; // null here is used to indicate that they don't want automatic updates.
  projectType: Project['type'];
  vcsHost: Project['vcs_host'] | null;
};

export const pickUpdateHooksSettingsFromProject = ({
  type: projectType,
  updateHook,
  vcs_host: vcsHost,
  require_mediated_dependencies: isProvided,
}: Project): ProjectUpdateHooksSettings => {
  return {
    projectType,
    vcsHost,
    //  Project.type is probably more cannonical here, but historically we've used require_mediated_dependencies to determine if a project is provided.
    isProvidedProject: projectType === 'provided' || !!isProvided,
    updateHook: updateHook
      ? _.pick(updateHook, projectUpdateHooksSettingsFields)
      : null,
  };
};

//  The saved body. A null updateHook turns automatic updates off, which Partial<Project> can't express.
export type ProjectUpdateHooksSave = Pick<ProjectUpdateHooksSettings, 'updateHook'>;

//  FOSSA registers Bitbucket Cloud secrets from Auto-regenerate Hook, and this page never shows one. Saving its copy
//  could clear a secret stored after the page loaded, so a Bitbucket Cloud save leaves secret_key alone.
export const convertUpdateHooksSettingsToProject = ({ updateHook }: ProjectUpdateHooksSettings): ProjectUpdateHooksSave => ({
  updateHook: updateHook?.type === 'bitbucket_cloud' ? _.omit(updateHook, 'secret_key') : updateHook,
});
